import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _defineProperty from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*! MIT License © Sindre Sorhus */

var globals = {};
var getGlobal = function getGlobal(property) {
  /* istanbul ignore next */
  if (typeof self !== 'undefined' && self && property in self) {
    return self;
  }

  /* istanbul ignore next */
  if (typeof window !== 'undefined' && window && property in window) {
    return window;
  }
  if (typeof global !== 'undefined' && global && property in global) {
    return global;
  }

  /* istanbul ignore next */
  if (typeof globalThis !== 'undefined' && globalThis) {
    return globalThis;
  }
};
var globalProperties = ['Headers', 'Request', 'Response', 'ReadableStream', 'fetch', 'AbortController', 'FormData'];
var _loop = function _loop() {
  var property = _globalProperties[_i];
  Object.defineProperty(globals, property, {
    get: function get() {
      var globalObject = getGlobal(property);
      var value = globalObject && globalObject[property];
      return typeof value === 'function' ? value.bind(globalObject) : value;
    }
  });
};
for (var _i = 0, _globalProperties = globalProperties; _i < _globalProperties.length; _i++) {
  _loop();
}
var isObject = function isObject(value) {
  return value !== null && typeof value === 'object';
};
var supportsAbortController = typeof globals.AbortController === 'function';
var supportsStreams = typeof globals.ReadableStream === 'function';
var _deepMerge = function deepMerge() {
  var returnValue = {};
  for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }
  for (var _i2 = 0, _sources = sources; _i2 < _sources.length; _i2++) {
    var source = _sources[_i2];
    if (Array.isArray(source)) {
      if (!Array.isArray(returnValue)) {
        returnValue = [];
      }
      returnValue = [].concat(_toConsumableArray(returnValue), _toConsumableArray(source));
    } else if (isObject(source)) {
      for (var _i3 = 0, _Object$entries = Object.entries(source); _i3 < _Object$entries.length; _i3++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i3], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];
        if (isObject(value) && Reflect.has(returnValue, key)) {
          value = _deepMerge(returnValue[key], value);
        }
        returnValue = _objectSpread({}, returnValue, _defineProperty({}, key, value));
      }
    }
  }
  return returnValue;
};
var requestMethods = ['get', 'post', 'put', 'patch', 'head', 'delete'];
var responseTypes = {
  json: 'application/json',
  text: 'text/*',
  formData: 'multipart/form-data',
  arrayBuffer: '*/*',
  blob: '*/*'
};
var retryMethods = ['get', 'put', 'head', 'delete', 'options', 'trace'];
var retryStatusCodes = [408, 413, 429, 500, 502, 503, 504];
var retryAfterStatusCodes = [413, 429, 503];
var stop = Symbol('stop');
var HTTPError = /*#__PURE__*/function (_Error) {
  _inherits(HTTPError, _Error);
  function HTTPError(response) {
    var _this;
    _classCallCheck(this, HTTPError);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(HTTPError).call(this, response.statusText));
    _this.name = 'HTTPError';
    _this.response = response;
    return _this;
  }
  return HTTPError;
}(_wrapNativeSuper(Error));
var TimeoutError = /*#__PURE__*/function (_Error2) {
  _inherits(TimeoutError, _Error2);
  function TimeoutError() {
    var _this2;
    _classCallCheck(this, TimeoutError);
    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(TimeoutError).call(this, 'Request timed out'));
    _this2.name = 'TimeoutError';
    return _this2;
  }
  return TimeoutError;
}(_wrapNativeSuper(Error));
var delay = function delay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

// `Promise.race()` workaround (#91)
var timeout = function timeout(promise, ms, abortController) {
  return new Promise(function (resolve, reject) {
    var timeoutID = setTimeout(function () {
      if (abortController) {
        abortController.abort();
      }
      reject(new TimeoutError());
    }, ms);

    /* eslint-disable promise/prefer-await-to-then */
    promise.then(resolve).catch(reject).then(function () {
      clearTimeout(timeoutID);
    });
    /* eslint-enable promise/prefer-await-to-then */
  });
};
var normalizeRequestMethod = function normalizeRequestMethod(input) {
  return requestMethods.includes(input) ? input.toUpperCase() : input;
};
var defaultRetryOptions = {
  limit: 2,
  methods: retryMethods,
  statusCodes: retryStatusCodes,
  afterStatusCodes: retryAfterStatusCodes
};
var normalizeRetryOptions = function normalizeRetryOptions() {
  var retry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (typeof retry === 'number') {
    return _objectSpread({}, defaultRetryOptions, {
      limit: retry
    });
  }
  if (retry.methods && !Array.isArray(retry.methods)) {
    throw new Error('retry.methods must be an array');
  }
  if (retry.statusCodes && !Array.isArray(retry.statusCodes)) {
    throw new Error('retry.statusCodes must be an array');
  }
  return _objectSpread({}, defaultRetryOptions, retry, {
    afterStatusCodes: retryAfterStatusCodes
  });
};

// The maximum value of a 32bit int (see issue #117)
var maxSafeTimeout = 2147483647;
var Ky = /*#__PURE__*/function () {
  function Ky(input) {
    var _this3 = this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Ky);
    this._retryCount = 0;
    this._input = input;
    this._options = _objectSpread({
      // TODO: credentials can be removed when the spec change is implemented in all browsers. Context: https://www.chromestatus.com/feature/4539473312350208
      credentials: this._input.credentials || 'same-origin'
    }, options, {
      hooks: _deepMerge({
        beforeRequest: [],
        beforeRetry: [],
        afterResponse: []
      }, options.hooks),
      method: normalizeRequestMethod(options.method || this._input.method),
      prefixUrl: String(options.prefixUrl || ''),
      retry: normalizeRetryOptions(options.retry),
      throwHttpErrors: options.throwHttpErrors !== false,
      timeout: typeof options.timeout === 'undefined' ? 10000 : options.timeout
    });
    if (typeof this._input !== 'string' && !(this._input instanceof URL || this._input instanceof globals.Request)) {
      throw new TypeError('`input` must be a string, URL, or Request');
    }
    if (this._options.prefixUrl && typeof this._input === 'string') {
      if (this._input.startsWith('/')) {
        throw new Error('`input` must not begin with a slash when using `prefixUrl`');
      }
      if (!this._options.prefixUrl.endsWith('/')) {
        this._options.prefixUrl += '/';
      }
      this._input = this._options.prefixUrl + this._input;
    }
    if (supportsAbortController) {
      this.abortController = new globals.AbortController();
      if (this._options.signal) {
        this._options.signal.addEventListener('abort', function () {
          _this3.abortController.abort();
        });
      }
      this._options.signal = this.abortController.signal;
    }
    this.request = new globals.Request(this._input, this._options);
    if (this._options.searchParams) {
      var url = new URL(this.request.url);
      url.search = new URLSearchParams(this._options.searchParams);
      this.request = new globals.Request(new globals.Request(url, this.request), this._options);
    }
    if (this._options.json !== undefined) {
      this._options.body = JSON.stringify(this._options.json);
      this.request.headers.set('content-type', 'application/json');
      this.request = new globals.Request(this.request, {
        body: this._options.body
      });
    }
    var fn = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var response, _iterator, _step, hook, modifiedResponse;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(_this3._options.timeout > maxSafeTimeout)) {
                _context.next = 2;
                break;
              }
              throw new RangeError("The `timeout` option cannot be greater than ".concat(maxSafeTimeout));
            case 2:
              _context.next = 4;
              return delay(1);
            case 4:
              _context.next = 6;
              return _this3._fetch();
            case 6:
              response = _context.sent;
              _iterator = _createForOfIteratorHelper(_this3._options.hooks.afterResponse);
              _context.prev = 8;
              _iterator.s();
            case 10:
              if ((_step = _iterator.n()).done) {
                _context.next = 18;
                break;
              }
              hook = _step.value;
              _context.next = 14;
              return hook(_this3.request, _this3._options, response.clone());
            case 14:
              modifiedResponse = _context.sent;
              if (modifiedResponse instanceof globals.Response) {
                response = modifiedResponse;
              }
            case 16:
              _context.next = 10;
              break;
            case 18:
              _context.next = 23;
              break;
            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](8);
              _iterator.e(_context.t0);
            case 23:
              _context.prev = 23;
              _iterator.f();
              return _context.finish(23);
            case 26:
              if (!(!response.ok && _this3._options.throwHttpErrors)) {
                _context.next = 28;
                break;
              }
              throw new HTTPError(response);
            case 28:
              if (!_this3._options.onDownloadProgress) {
                _context.next = 34;
                break;
              }
              if (!(typeof _this3._options.onDownloadProgress !== 'function')) {
                _context.next = 31;
                break;
              }
              throw new TypeError('The `onDownloadProgress` option must be a function');
            case 31:
              if (supportsStreams) {
                _context.next = 33;
                break;
              }
              throw new Error('Streams are not supported in your environment. `ReadableStream` is missing.');
            case 33:
              return _context.abrupt("return", _this3._stream(response.clone(), _this3._options.onDownloadProgress));
            case 34:
              return _context.abrupt("return", response);
            case 35:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[8, 20, 23, 26]]);
      }));
      return function fn() {
        return _ref.apply(this, arguments);
      };
    }();
    var isRetriableMethod = this._options.retry.methods.includes(this.request.method.toLowerCase());
    var result = isRetriableMethod ? this._retry(fn) : fn();
    var _loop2 = function _loop2() {
      var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i4], 2),
        type = _Object$entries2$_i[0],
        mimeType = _Object$entries2$_i[1];
      result[type] = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.request.headers.set('accept', _this3.request.headers.get('accept') || mimeType);
              _context2.next = 3;
              return result;
            case 3:
              response = _context2.sent.clone();
              return _context2.abrupt("return", type === 'json' && response.status === 204 ? '' : response[type]());
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
    };
    for (var _i4 = 0, _Object$entries2 = Object.entries(responseTypes); _i4 < _Object$entries2.length; _i4++) {
      _loop2();
    }
    return result;
  }
  _createClass(Ky, [{
    key: "_calculateRetryDelay",
    value: function _calculateRetryDelay(error) {
      this._retryCount++;
      if (this._retryCount < this._options.retry.limit && !(error instanceof TimeoutError)) {
        if (error instanceof HTTPError) {
          if (!this._options.retry.statusCodes.includes(error.response.status)) {
            return 0;
          }
          var retryAfter = error.response.headers.get('Retry-After');
          if (retryAfter && this._options.retry.afterStatusCodes.includes(error.response.status)) {
            var after = Number(retryAfter);
            if (Number.isNaN(after)) {
              after = Date.parse(retryAfter) - Date.now();
            } else {
              after *= 1000;
            }
            if (typeof this._options.retry.maxRetryAfter !== 'undefined' && after > this._options.retry.maxRetryAfter) {
              return 0;
            }
            return after;
          }
          if (error.response.status === 413) {
            return 0;
          }
        }
        var BACKOFF_FACTOR = 0.3;
        return BACKOFF_FACTOR * Math.pow(2, this._retryCount - 1) * 1000;
      }
      return 0;
    }
  }, {
    key: "_retry",
    value: function () {
      var _retry2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(fn) {
        var ms, _iterator2, _step2, hook, hookResult;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return fn();
            case 3:
              return _context3.abrupt("return", _context3.sent);
            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3["catch"](0);
              ms = Math.min(this._calculateRetryDelay(_context3.t0), maxSafeTimeout);
              if (!(ms !== 0 && this._retryCount > 0)) {
                _context3.next = 33;
                break;
              }
              _context3.next = 12;
              return delay(ms);
            case 12:
              _iterator2 = _createForOfIteratorHelper(this._options.hooks.beforeRetry);
              _context3.prev = 13;
              _iterator2.s();
            case 15:
              if ((_step2 = _iterator2.n()).done) {
                _context3.next = 24;
                break;
              }
              hook = _step2.value;
              _context3.next = 19;
              return hook({
                request: this.request,
                options: this._options,
                error: _context3.t0,
                response: _context3.t0.response.clone(),
                retryCount: this._retryCount
              });
            case 19:
              hookResult = _context3.sent;
              if (!(hookResult === stop)) {
                _context3.next = 22;
                break;
              }
              return _context3.abrupt("return");
            case 22:
              _context3.next = 15;
              break;
            case 24:
              _context3.next = 29;
              break;
            case 26:
              _context3.prev = 26;
              _context3.t1 = _context3["catch"](13);
              _iterator2.e(_context3.t1);
            case 29:
              _context3.prev = 29;
              _iterator2.f();
              return _context3.finish(29);
            case 32:
              return _context3.abrupt("return", this._retry(fn));
            case 33:
              if (!this._options.throwHttpErrors) {
                _context3.next = 35;
                break;
              }
              throw _context3.t0;
            case 35:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 6], [13, 26, 29, 32]]);
      }));
      function _retry(_x) {
        return _retry2.apply(this, arguments);
      }
      return _retry;
    }()
  }, {
    key: "_fetch",
    value: function () {
      var _fetch2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _iterator3, _step3, hook, result;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _iterator3 = _createForOfIteratorHelper(this._options.hooks.beforeRequest);
              _context4.prev = 1;
              _iterator3.s();
            case 3:
              if ((_step3 = _iterator3.n()).done) {
                _context4.next = 15;
                break;
              }
              hook = _step3.value;
              _context4.next = 7;
              return hook(this.request, this._options);
            case 7:
              result = _context4.sent;
              if (!(result instanceof Request)) {
                _context4.next = 11;
                break;
              }
              this.request = result;
              return _context4.abrupt("break", 15);
            case 11:
              if (!(result instanceof Response)) {
                _context4.next = 13;
                break;
              }
              return _context4.abrupt("return", result);
            case 13:
              _context4.next = 3;
              break;
            case 15:
              _context4.next = 20;
              break;
            case 17:
              _context4.prev = 17;
              _context4.t0 = _context4["catch"](1);
              _iterator3.e(_context4.t0);
            case 20:
              _context4.prev = 20;
              _iterator3.f();
              return _context4.finish(20);
            case 23:
              if (!(this._options.timeout === false)) {
                _context4.next = 25;
                break;
              }
              return _context4.abrupt("return", globals.fetch(this.request.clone()));
            case 25:
              return _context4.abrupt("return", timeout(globals.fetch(this.request.clone()), this._options.timeout, this.abortController));
            case 26:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[1, 17, 20, 23]]);
      }));
      function _fetch() {
        return _fetch2.apply(this, arguments);
      }
      return _fetch;
    }() /* istanbul ignore next */
  }, {
    key: "_stream",
    value: function _stream(response, onDownloadProgress) {
      var totalBytes = Number(response.headers.get('content-length')) || 0;
      var transferredBytes = 0;
      return new globals.Response(new globals.ReadableStream({
        start: function start(controller) {
          var reader = response.body.getReader();
          if (onDownloadProgress) {
            onDownloadProgress({
              percent: 0,
              transferredBytes: 0,
              totalBytes: totalBytes
            }, new Uint8Array());
          }
          function read() {
            return _read.apply(this, arguments);
          }
          function _read() {
            _read = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
              var _yield$reader$read, done, value, percent;
              return _regeneratorRuntime().wrap(function _callee5$(_context5) {
                while (1) switch (_context5.prev = _context5.next) {
                  case 0:
                    _context5.next = 2;
                    return reader.read();
                  case 2:
                    _yield$reader$read = _context5.sent;
                    done = _yield$reader$read.done;
                    value = _yield$reader$read.value;
                    if (!done) {
                      _context5.next = 8;
                      break;
                    }
                    controller.close();
                    return _context5.abrupt("return");
                  case 8:
                    if (onDownloadProgress) {
                      transferredBytes += value.byteLength;
                      percent = totalBytes === 0 ? 0 : transferredBytes / totalBytes;
                      onDownloadProgress({
                        percent: percent,
                        transferredBytes: transferredBytes,
                        totalBytes: totalBytes
                      }, value);
                    }
                    controller.enqueue(value);
                    read();
                  case 11:
                  case "end":
                    return _context5.stop();
                }
              }, _callee5);
            }));
            return _read.apply(this, arguments);
          }
          read();
        }
      }));
    }
  }]);
  return Ky;
}();
var validateAndMerge = function validateAndMerge() {
  for (var _len2 = arguments.length, sources = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    sources[_key2] = arguments[_key2];
  }
  for (var _i5 = 0, _sources2 = sources; _i5 < _sources2.length; _i5++) {
    var source = _sources2[_i5];
    if ((!isObject(source) || Array.isArray(source)) && typeof source !== 'undefined') {
      throw new TypeError('The `options` argument must be an object');
    }
  }
  return _deepMerge.apply(void 0, [{}].concat(sources));
};
var _createInstance = function createInstance(defaults) {
  var ky = function ky(input, options) {
    return new Ky(input, validateAndMerge(defaults, options));
  };
  var _loop3 = function _loop3() {
    var method = _requestMethods[_i6];
    ky[method] = function (input, options) {
      return new Ky(input, validateAndMerge(defaults, options, {
        method: method
      }));
    };
  };
  for (var _i6 = 0, _requestMethods = requestMethods; _i6 < _requestMethods.length; _i6++) {
    _loop3();
  }
  ky.HTTPError = HTTPError;
  ky.TimeoutError = TimeoutError;
  ky.create = function (newDefaults) {
    return _createInstance(validateAndMerge(newDefaults));
  };
  ky.extend = function (newDefaults) {
    return _createInstance(validateAndMerge(defaults, newDefaults));
  };
  ky.stop = stop;
  return ky;
};
export default _createInstance();